var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowOutLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7912 11.0046H7.62124L12.5012 6.12461C12.8912 5.73461 12.8912 5.09461 12.5012 4.70461C12.1112 4.31461 11.4812 4.31461 11.0912 4.70461L4.50124 11.2946C4.11124 11.6846 4.11124 12.3146 4.50124 12.7046L11.0912 19.2946C11.4812 19.6846 12.1112 19.6846 12.5012 19.2946C12.8912 18.9046 12.8912 18.2746 12.5012 17.8846L7.62124 13.0046H18.7912C19.3412 13.0046 19.7912 12.5546 19.7912 12.0046C19.7912 11.4546 19.3412 11.0046 18.7912 11.0046Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutLeftIcon);
export default __webpack_public_path__ + "static/media/ArrowOutLeftIcon.32f547fff20e17eda4b9ece823a6740f.svg";
export { ForwardRef as ReactComponent };